<script>
  export let widgets;
  export let summary;
  export let image = null;

  import { debug } from "../store.js";

  import Heading from "./Heading.svelte";
  import Image from "./Image.svelte";
  import Text from "./Text.svelte";
  import Puzzle from "./Puzzle.svelte";
  import Benefit from "./Benefit.svelte";
  import Container from "./Container.svelte";
  import Audio from "./Audio.svelte";
  import Video from "./Video.svelte";
  import Link from "./Link.svelte";
  import Button from "./Button.svelte";
  import Margin from "./Margin.svelte";
  import Embed from "./Embed.svelte";

  export const widgetDefs = {
    heading: Heading,
    image: Image,
    text: Text,
    puzzle: Puzzle,
    benefit: Benefit,
    audio: Audio,
    video: Video,
    link: Link,
    container: Container,
    button: Button,
    margin: Margin,
    embed: Embed,
  };
</script>

<details>
  <summary class="locked-widget-summary">
    {#if image}<img src={image} class="details-img" alt="Details" />{/if}
    <div class="summary-container">
      <Text content={summary} />
    </div>
  </summary>
  <div class="details-content">
    {#each widgets as widget}
      <div class="locked-widget" class:debug={$debug} data-type={widget.type}>
        <svelte:component this={widgetDefs[widget.type]} {...widget} />
      </div>
    {/each}
  </div>
</details>

<style type="text/scss">
  details {
    text-align: left;

    summary {
      cursor: pointer;
      display: flex;
      vertical-align: middle;
      //width: 100%;

      &::-webkit-details-marker {
        display: none;
      }

      .summary-container:before {
        content: "► ";
        display: flex;
        flex-direction: column;
        justify-content: center;
      }

      .summary-container {
        width: calc(
          100% - 50px
        ); /* 50px is the space taken by summary::before */
        display: inline-flex;
        flex: 1;
      }

      img {
        object-fit: contain;
        transition: transform 0.05s ease-in-out;
        margin-right: 0.33em;

        &:hover {
          transform: scale(1.05);
        }
      }
    }

    .details-content {
      text-align: center;
      margin-left: -1.1em;
      margin-right: -1.1em;
      margin-bottom: 1em;
      background-color: #eaeaea;
      padding: 1em 0.33em;
    }
  }

  // (https://stackoverflow.com/a/52583024/8833247)
  // https://stackoverflow.com/a/51131819/8833247
  details[open] summary {
    .summary-container:before {
      content: "▼ ";
    }
  }
</style>
